import getSelectedTableView from '../utils/getSelectedTableView';
import getComputedSelectedRowKeysSize from '../utils/getComputedSelectedRowKeysSize';
import getListViewState from '../selectors/getListViewState';
import getAreAllChildrenSelectedInConversation from '../utils/getAreAllChildrenSelectedInConversation';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export default function isItemPartOperation(): boolean {
    const tableView = getSelectedTableView();

    if (!tableView || !tableView.selectedRowKeys) {
        return false;
    }

    if (isGlobalFeatureEnabled('fwk-ml-reduce-render-scope')) {
        // Use the computed size selector instead of reading selectedRowKeys.size directly.
        // This avoids creating a MobX dependency on the Map itself — when selection changes
        // from one row to another (size stays 1), this computed won't be invalidated.
        if (getComputedSelectedRowKeysSize() !== 1) {
            return false;
        }

        // Check expanded conversation state first — this is a cheaper observable read
        // and allows early exit before we need to read the actual selected key from the Map.
        const expandedState = getListViewState().expandedConversationViewState;
        if (!expandedState?.selectedNodeIds?.length) {
            return false;
        }

        const selectedRowKey = [...tableView.selectedRowKeys.keys()][0];
        return !getAreAllChildrenSelectedInConversation(selectedRowKey, tableView);
    }

    const selectedRowKeys = tableView.selectedRowKeys;

    if (selectedRowKeys.size !== 1) {
        return false;
    }

    const selectedRowKey = [...selectedRowKeys.keys()][0];

    // If a conversation has at least 1 but not all of its item parts selected, then it is an item part operation.
    return (
        getListViewState().expandedConversationViewState?.selectedNodeIds?.length > 0 &&
        !getAreAllChildrenSelectedInConversation(selectedRowKey, tableView)
    );
}
